(function(){
  var jsonEl = document.querySelector('script[type="application/json"][data-ec-lens-data]');
  if(!jsonEl) return;
  var D;
  try { D = JSON.parse(jsonEl.textContent); } catch(e){ return; }

  function ecT(k) { return jsonEl.getAttribute('data-lp-i18n-' + k) || ''; }
  function ecTf(k, vars) {
    return ecT(k).replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, n) {
      return vars && vars.hasOwnProperty(n) ? String(vars[n]) : m;
    });
  }
  function esc(v) { return String(v).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }

  var idxSel = document.querySelector('select[name="options['+D.idxName+']"]');
  var typeSel = document.querySelector('select[name="options['+D.typeName+']"]');
  if(!idxSel || !typeSel) return;


  var colorPos=1, idxPos=D.idxPos, typePos=D.typePos;
  [1,2,3].forEach(function(p){ if(p!==idxPos && p!==typePos) colorPos=p; });

  function vOpt(v,pos){ return v['o'+pos]; }

  var JOIN=' + ';
  var comboParts={}, comboOf={}, hasCombos=false;
  D.typeValues.forEach(function(val){
    var from=0, at;
    while((at=val.indexOf(JOIN,from))>-1){
      var a=val.substring(0,at), b=val.substring(at+JOIN.length);
      if(D.typeValues.indexOf(a)>-1 && D.typeValues.indexOf(b)>-1){
        comboParts[val]=[a,b];
        (comboOf[a]=comboOf[a]||{})[b]=val;
        (comboOf[b]=comboOf[b]||{})[a]=val;
        hasCombos=true;
        break;
      }
      from=at+JOIN.length;
    }
  });
  var singleTypes=D.typeValues.filter(function(val){ return !comboParts[val]; });
  function partsOf(val){ return comboParts[val] || [val]; }
  function comboVal(a,b){ return (comboOf[a] && comboOf[a][b]) || null; }

  var TINT_TYPES=['Blush Tint'];
  function isTint(val){
    return partsOf(val).some(function(part){
      return TINT_TYPES.some(function(name){ return part.indexOf(name)===0; });
    });
  }
  function hasAdd(){
    var seen={}, found=false;
    document.querySelectorAll('select[name^="Add"], input[name^="Add"], select[name^="properties[Add"], input[name^="properties[Add"]').forEach(function(el){
      var bare=el.name.replace(/^properties\[/,'').replace(/\]$/,'');
      if(seen[bare] || !/^Add\b/.test(bare)) return;
      seen[bare]=true;
      if(num(el.value)!==0) found=true;
    });
    return found;
  }
  function tintClash(){ return hasAdd() && isTint(typeSel.value); }

  function indexMax(txt){
    if(/NO\s*RX/i.test(txt)) return 0;
    if(/CYL/i.test(txt)) return Infinity;
    if(/and\s*above/i.test(txt)) return Infinity;
    var m = txt.match(/to\s*-?\/?\+?\s*(\d+(?:\.\d+)?)/i);
    if(m) return parseFloat(m[1]);
    return Infinity;
  }
  function isDemo(txt){ return /NO\s*RX/i.test(txt); }
  function isSpecial(txt){ return /CYL/i.test(txt) && !/NO\s*RX/i.test(txt); }
  var AUTO_INDEX_MAX = 1.67;
  function indexNum(txt){ var n=parseFloat(txt); return isNaN(n) ? Infinity : n; }
  var ladder = D.indexValues.filter(function(t){ return !isDemo(t) && !isSpecial(t); });
  var specialVal = null;
  for(var si=0; si<D.indexValues.length; si++){ if(isSpecial(D.indexValues[si])){ specialVal=D.indexValues[si]; break; } }

  function num(s){ if(s==null) return 0; s=(''+s).replace('--','').trim(); if(!s) return 0; var n=parseFloat(s); return isNaN(n)?0:n; }
  function rxState(){
    function val(name){
      var el=document.querySelector('select[name="'+name+'"], select[name="properties['+name+']"]');
      return el?el.value:'';
    }
    var sphR=num(val('Sph (Right OD)')), sphL=num(val('Sph (Left OS)'));
    var cylR=num(val('Cyl (Right OD)')), cylL=num(val('Cyl (Left OS)'));
    var axR=num(val('Axis (Right OD)')), axL=num(val('Axis (Left OS)'));
    var addRaw=val('Add'); var add=num(addRaw);
    var anyRx = sphR||sphL||cylR||cylL||axR||axL||add||(addRaw && addRaw!=='--');
    return {
      maxSph: Math.max(Math.abs(sphR),Math.abs(sphL)),
      maxCyl: Math.max(Math.abs(cylR),Math.abs(cylL)),
      anyRx: !!anyRx
    };
  }

  function idxHasStock(idxVal){
    var color = idxSel && colorVal();
    return D.variants.some(function(v){ return v.a && vOpt(v,idxPos)===idxVal && (!color || vOpt(v,colorPos)===color); });
  }
  function colorVal(){
    var sw = document.querySelector('.product__color-swatch.selected[data-option-value]');
    if(sw) return sw.getAttribute('data-option-value');
    return null;
  }

  var wizardGo=null;
  var typePicked=false, idxPicked=false, usageChosen=false;
  var syncBuy=function(){};
  var tintNote=function(){};
  var isPlano=function(){ return false; };
  var isRxPath=function(){ return false; };

  function asButton(el){
    el.setAttribute('role','button');
    el.setAttribute('tabindex','0');
    el.setAttribute('aria-pressed','false');
    el.addEventListener('keydown', function(e){
      if(e.key==='Enter' || e.key===' ' || e.key==='Spacebar' || e.keyCode===13 || e.keyCode===32){
        e.preventDefault();
        el.click();
      }
    });
  }
  function setOff(el, off){
    el.classList.toggle('is-disabled', off);
    if(off){ el.setAttribute('aria-disabled','true'); el.setAttribute('tabindex','-1'); }
    else { el.removeAttribute('aria-disabled'); el.setAttribute('tabindex','0'); }
  }
  var idxWrap = idxSel.closest('.select-wrapper') || idxSel.parentElement;
  var idxRow = document.createElement('div');
  idxRow.className='ec-lp ec-lp__row ec-lp__idx';
  D.indexValues.forEach(function(val){
    var box=document.createElement('div');
    box.className='ec-lp__box';
    box.setAttribute('data-val', val);
    var label = val.match(/^([\d.]+)\s*index/i);
    var lbl = label ? label[1] : (isSpecial(val)?esc(ecT('special')):(isDemo(val)?esc(ecT('demo')):val));
    var sub;
    if(isDemo(val)) sub=esc(ecT('demo-sub'));
    else if(isSpecial(val)) sub=esc(ecT('special-sub'));
    else {
      var mm=val.match(/for\s*SPH\s*(.+?)\)/i);
      var t=mm?mm[1].replace(/-\/\+|\+\/-/g,'±').trim():'';
      var above=t.match(/±?([\d.]+)\s*and\s*above/i);
      var zeroTo=t.match(/^0(?:\.00)?\s*to\s*±?([\d.]+)/i);
      var range=t.match(/(±?[\d.]+)\s*to\s*±?([\d.]+)/i);
      if(above) sub=esc(ecTf('sph-above', { value: above[1] }));
      else if(zeroTo) sub=esc(ecTf('sph-up-to', { value: zeroTo[1] }));
      else if(range) sub=esc(ecTf('sph-range', { from: (range[1].indexOf('±')>-1?range[1]:'±'+range[1]), to: range[2] }));
      else sub=esc(ecTf('sph-raw', { range: t }));
    }
    box.innerHTML='<span class="ec-lp__box-lbl">'+lbl+'</span>'+(sub?'<span class="ec-lp__box-sub">'+sub+'</span>':'')+'<span class="ec-lp__card-delta" data-idelta></span>';
    box.addEventListener('click', function(){ if(box.classList.contains('is-disabled')) return; idxPicked=true; setIndex(val); });
    asButton(box);
    idxRow.appendChild(box);
  });
  idxSel.classList.add('ec-lp-hidden-native');
  idxWrap.classList.add('ec-lp-native-wrap');
  idxWrap.parentNode.insertBefore(idxRow, idxWrap.nextSibling);

  function cardFor(val){ for(var i=0;i<D.typeCards.length;i++){ if((D.typeCards[i].match||'').trim()===val) return D.typeCards[i]; } return null; }
  function monogram(val, card){
    if(card && card.mono) return card.mono;
    var m=val.match(/[A-Z]{2,}/); if(m) return m[0].substring(0,3);
    var w=val.replace(/[()]/g,'').split(/[\s-]+/).filter(Boolean);
    return ((w[0]||'').charAt(0)+(w[1]||'').charAt(0)).toUpperCase() || val.substring(0,2).toUpperCase();
  }
  var typeWrap = typeSel.closest('.select-wrapper') || typeSel.parentElement;
  var typeRow = document.createElement('div');
  typeRow.className='ec-lp ec-lp__row ec-lp__type';
  singleTypes.forEach(function(val){
    var card=cardFor(val);
    var el=document.createElement('div');
    el.className='ec-lp__card';
    el.setAttribute('data-val', val);
    var media = (card && card.img) ? '<div class="ec-lp__card-media" style="background-image:url('+card.img+')"></div>' : '';
    if(!media) el.classList.add('ec-lp__card--noimg');
    var badge=(card&&card.badge)?'<span class="ec-lp__badge">'+card.badge+'</span>':'';
    var cap=(card&&card.caption)?'<span class="ec-lp__card-cap">'+card.caption+'</span>':'';
    el.innerHTML=badge+media+'<div class="ec-lp__card-body"><span class="ec-lp__card-name">'+val+'</span>'+cap+'<span class="ec-lp__card-delta" data-delta></span></div>';
    el.addEventListener('click', function(){
      if(el.classList.contains('is-disabled')) return;
      tintNote(false);
      typePicked=true;
      if(hasCombos){
        pickType(val);
        var now=partsOf(typeSel.value);
        if(now.length===1 && !hasPartner(now[0]) && wizardGo) wizardGo();
        return;
      }
      setType(val); if(wizardGo) wizardGo();
    });
    asButton(el);
    typeRow.appendChild(el);
  });
  typeSel.classList.add('ec-lp-hidden-native');
  typeWrap.classList.add('ec-lp-native-wrap');
  typeWrap.parentNode.insertBefore(typeRow, typeWrap.nextSibling);
  typeRow.addEventListener('click', function(e){
    if(e.target.closest && e.target.closest('.ec-lp__card')) return;
    var hit=null;
    typeRow.querySelectorAll('.ec-lp__card.is-disabled').forEach(function(c){
      var b=c.getBoundingClientRect();
      if(e.clientX>=b.left && e.clientX<=b.right && e.clientY>=b.top && e.clientY<=b.bottom) hit=c;
    });
    if(hit && hasAdd() && isTint(hit.getAttribute('data-val'))) tintNote(true, true);
  });


  var placed = (function relocate(){
    var idxOpt=idxSel.closest('.product__option'), typeOpt=typeSel.closest('.product__option');
    if(!idxOpt || !typeOpt) return null;
    var meta=idxOpt.closest('.product__meta'); if(!meta) return null;
    function metaChild(node){ var b=node; while(b && b.parentElement!==meta) b=b.parentElement; return (b && b.parentElement===meta) ? b : null; }
    var offer=meta.querySelector('.ec-ot');
    var buyForm=meta.querySelector('form[action*="/cart/add"]');
    var buyBlock=buyForm?metaChild(buyForm):null;
    if(buyBlock){
      var cbBlocks=Array.prototype.filter.call(meta.children, function(c){ return c!==buyBlock && c.querySelector && c.querySelector('input[type=checkbox]'); });
      if(cbBlocks.length){
        var cbFirst=cbBlocks.filter(function(cb){ return !cb.hasAttribute('data-ec-rx-only'); })[0] || cbBlocks[0];
        cbFirst.classList.add('ec-lp-required-first');
        cbBlocks.forEach(function(cb){ meta.insertBefore(cb, buyBlock); });
      }
    }
    var anchor=(offer?metaChild(offer):null) || buyBlock;
    if(!anchor) return null;
    meta.insertBefore(typeOpt, anchor);
    meta.insertBefore(idxOpt, anchor);
    return { meta: meta, idxOpt: idxOpt, typeOpt: typeOpt };
  })();

  (function wizard(){
    if(!placed) return;
    var meta=placed.meta, idxOpt=placed.idxOpt, typeOpt=placed.typeOpt;
    var pd=document.querySelector('select[name="PD"], input[name="PD"], select[name="properties[PD]"], input[name="properties[PD]"]');
    if(!pd) return;
    function metaChild(node){ var b=node; while(b && b.parentElement!==meta) b=b.parentElement; return (b && b.parentElement===meta) ? b : null; }
    var kids=Array.prototype.slice.call(meta.children);
    var endIdx=kids.indexOf(idxOpt)-1;
    var sph=document.querySelector('select[name="Sph (Right OD)"]');
    var firstRx=sph?metaChild(sph):null;
    var start=-1;
    for(var i=0;i<kids.length;i++){ if(/customize your lenses/i.test(kids[i].textContent||'')){ start=i; break; } }
    if(start>=0) start=start+1;
    if(start<0 && firstRx) start=kids.indexOf(firstRx);
    if(start<0 || endIdx<start) return;
    var pdIdx=kids.indexOf(metaChild(pd));
    if(pdIdx<start || pdIdx>endIdx) return;
    if(firstRx){ var rxIdx=kids.indexOf(firstRx); if(rxIdx<start || rxIdx>endIdx) return; }

    var hasUsage = true;
    var S_USAGE = hasUsage ? 0 : -1;
    var S_RX    = hasUsage ? 1 : 0;
    var S_TYPE  = S_RX + 1;
    var S_INDEX = S_RX + 2;

    var wrap=document.createElement('div'); wrap.className='ec-lpw';
    var vp=document.createElement('div'); vp.className='ec-lpw__viewport';
    var track=document.createElement('div'); track.className='ec-lpw__track';
    var scrUsage = hasUsage ? document.createElement('div') : null;
    if(scrUsage) scrUsage.className='ec-lpw__screen ec-lpw__screen--usage';
    var scrRx=document.createElement('div'); scrRx.className='ec-lpw__screen ec-lpw__screen--rx';
    var scrIndex=document.createElement('div'); scrIndex.className='ec-lpw__screen ec-lpw__screen--index';
    var scrType=document.createElement('div'); scrType.className='ec-lpw__screen ec-lpw__screen--type';
    var screens = hasUsage ? [scrUsage,scrRx,scrType,scrIndex] : [scrRx,scrType,scrIndex];
    screens.forEach(function(s){ track.appendChild(s); });
    vp.appendChild(track);
    var stepEls=[];
    var steps=document.createElement('div'); steps.className='ec-lpw__steps';
    function stepBtn(i,label){
      var b=document.createElement('button');
      b.type='button'; b.className='ec-lpw__step';
      b.setAttribute('data-step',i);
      b.textContent=label;
      b.addEventListener('click', function(){ go(i); });
      steps.appendChild(b);
      stepEls.push(b);
      return b;
    }
    if(hasUsage) stepBtn(S_USAGE,ecTf('step-usage', { number: '1' }));
    stepBtn(S_RX,   ecTf('step-prescription', { number: (hasUsage?'2':'1') }));
    stepBtn(S_TYPE, ecTf('step-type', { number: (hasUsage?'3':'2') }));
    stepBtn(S_INDEX,ecTf('step-index', { number: (hasUsage?'4':'3') }));
    wrap.appendChild(steps); wrap.appendChild(vp);
    meta.insertBefore(wrap, kids[start]);
    for(var k=start;k<=endIdx;k++){
      var n=kids[k];
      if(n===wrap) continue;
      if(n.classList && n.classList.contains('modal-content')) continue;
      if(n.tagName==='SCRIPT' || n.tagName==='STYLE') continue;
      scrRx.appendChild(n);
    }

    var chev='<span class="icon icon-new icon-chevron"><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.875 7.438 12 17.563 22.125 7.438" stroke="currentColor" stroke-width="2"/></svg></span>';
    function navBar(dir,label,mod,target){
      var bar=document.createElement('div');
      bar.className='ec-lpw__navbar'+(mod?' '+mod:'');
      var b=document.createElement('button');
      b.type='button';
      b.className='ec-lpw__nav fs-body-75';
      b.setAttribute('data-dir',dir);
      b.innerHTML = dir==='back' ? chev+'<span>'+esc(label)+'</span>' : '<span>'+esc(label)+'</span>'+chev;
      b.addEventListener('click', function(){ go(target()); });
      bar.appendChild(b);
      return bar;
    }
    var nextBtn=document.createElement('button');
    nextBtn.type='button';
    nextBtn.className='btn btn--medium btn--full btn--primary ec-lpw__next';
    nextBtn.textContent=ecT('next-step');
    nextBtn.disabled=true;
    nextBtn.addEventListener('click', function(){ if(!nextBtn.disabled) go(S_TYPE); });
    scrRx.appendChild(nextBtn);
    var nextHelp=document.createElement('div');
    nextHelp.className='product__custom-option-instructions rte rte--product fs-body-75 t-opacity-70 ec-lpw__next-help';
    nextHelp.hidden=true;
    scrRx.appendChild(nextHelp);
    if(hasUsage) scrRx.insertBefore(navBar('back',ecT('previous-step'),'ec-lpw__navbar--top',function(){ return S_USAGE; }), scrRx.firstChild);
    scrType.appendChild(navBar('back',ecT('previous-step'),'ec-lpw__navbar--top',function(){ return (hasUsage && usage==='plano') ? S_USAGE : S_RX; }));
    scrType.appendChild(typeOpt);
    var typeNext=null;
    if(hasCombos){
      typeNext=document.createElement('button');
      typeNext.type='button';
      typeNext.className=nextBtn.className;
      typeNext.textContent=ecT('next-step');
      typeNext.addEventListener('click', function(){ go(S_INDEX); });
      typeNext.hidden=true;
      wrap.appendChild(typeNext);
    }
    scrIndex.appendChild(navBar('back',ecT('previous-step'),'ec-lpw__navbar--top',function(){ return S_TYPE; }));
    scrIndex.appendChild(idxOpt);
    (function(){
      var guideTrig=idxOpt.querySelector('a.product__information-popup');
      if(!guideTrig) return;
      var typeTrig=guideTrig.cloneNode(true);
      typeTrig.addEventListener('click', function(e){ e.preventDefault(); guideTrig.click(); });
      typeOpt.appendChild(typeTrig);
    })();

    var usage = hasUsage ? '' : 'rx';
    var usageSent=null;
    window.ECLensUsage=function(){ return usage; };
    function notifyUsage(){
      if(usageSent===usage) return;
      usageSent=usage;
      document.dispatchEvent(new CustomEvent('ec:lens-usage',{detail:{usage:usage}}));
    }
    isPlano=function(){ return hasUsage && usage==='plano'; };
    isRxPath=function(){ return usage==='rx'; };
    var usageRow=null, usePlano=null, useRx=null;
    function usageCard(kind,lbl,sub){
      var box=document.createElement('div');
      box.className='ec-lp__box';
      box.setAttribute('data-usage',kind);
      box.setAttribute('role','button');
      box.setAttribute('tabindex','0');
      box.setAttribute('aria-pressed','false');
      box.innerHTML='<span class="ec-lp__box-lbl">'+esc(lbl)+'</span><span class="ec-lp__box-sub">'+esc(sub)+'</span>';
      box.addEventListener('click', function(){ chooseUsage(kind); });
      box.addEventListener('keydown', function(e){
        if(e.key==='Enter' || e.key===' ' || e.key==='Spacebar' || e.keyCode===13 || e.keyCode===32){
          e.preventDefault();
          chooseUsage(kind);
        }
      });
      usageRow.appendChild(box);
      return box;
    }
    if(hasUsage){
      usageRow=document.createElement('div');
      usageRow.className='ec-lp ec-lp__row ec-lp__usage';
      usePlano=usageCard('plano',ecT('usage-plano'),ecT('usage-plano-sub'));
      useRx=usageCard('rx',ecT('usage-rx'),ecT('usage-rx-sub'));
      scrUsage.appendChild(usageRow);
    }

    var ZERO=/^([+-]?0(\.0+)?|--)$/;
    function fieldByName(nm){ return document.querySelector('select[name="'+nm+'"], input[name="'+nm+'"]'); }
    function setFieldValue(el,val){
      if(!el || el.value===val) return;
      el.value=val;
      el.dispatchEvent(new Event('change',{bubbles:true}));
    }
    function zeroField(nm){
      var el=fieldByName(nm); if(!el) return;
      if(!el.options){ setFieldValue(el,''); return; }
      for(var z=0;z<el.options.length;z++){
        var o=el.options[z];
        if(o.disabled) continue;
        if(ZERO.test((o.value||'').trim())){ setFieldValue(el,o.value); return; }
      }
    }
    function naOptionValue(){
      if(!pd.options) return null;
      for(var z=0;z<pd.options.length;z++){
        var v=(pd.options[z].value||'').trim();
        if(!v) continue;
        if(/^(na|n\/?a|none)$/i.test(v) || /^(n\/?a|none)\b/i.test(v)) return pd.options[z].value;
      }
      return null;
    }
    var NA_PD='N/A (for NON-PRESCRIPTION glasses ONLY)';
    function pdSelects(){
      var out=[];
      document.querySelectorAll('select[name="PD"], select[name="properties[PD]"]').forEach(function(el){ out.push(el); });
      return out;
    }
    function addNaOption(){
      pdSelects().forEach(function(sel){
        if(sel.querySelector('option[data-ec-na]')) return;
        var o=document.createElement('option');
        o.value=NA_PD; o.textContent=NA_PD; o.hidden=true;
        o.setAttribute('data-ec-na','');
        sel.appendChild(o);
      });
    }
    function dropNaOption(){
      pdSelects().forEach(function(sel){
        var o=sel.querySelector('option[data-ec-na]');
        if(!o) return;
        var was=sel.value===o.value;
        sel.removeChild(o);
        if(was){ sel.value=''; sel.dispatchEvent(new Event('change',{bubbles:true})); }
      });
    }
    function setPlanoFields(){
      ['Sph (Right OD)','Cyl (Right OD)','Axis (Right OD)','Sph (Left OS)','Cyl (Left OS)','Axis (Left OS)','Add'].forEach(zeroField);
      var na=naOptionValue();
      if(na===null){
        if(pd.options){ addNaOption(); na=NA_PD; }
        else { setFieldValue(pd,NA_PD); }
      }
      if(na!==null) setFieldValue(pd,na);
      updateNext();
    }
    function chooseUsage(kind){
      usage=kind;
      usageChosen=true;
      if(kind==='rx'){ dropNaOption(); go(S_RX); applyBase(); return; }
      setPlanoFields();
      applyBase();
      go(S_TYPE);
    }

    var ERR_NA=ecT('error-pd-na');
    var ERR_UNSET=ecT('error-pd-unset');
    var ERR_RANGE=ecT('error-rx-range');
    var pdBlock=kids[pdIdx];
    function injectPdPlaceholder(sel){
      if(!sel || sel.querySelector('option[value=""]')) return;
      var o=document.createElement('option');
      o.value=''; o.textContent=ecT('select-pd');
      o.disabled=true; o.selected=true; o.hidden=true;
      sel.insertBefore(o, sel.firstChild);
    }
    injectPdPlaceholder(pd);
    (function(){
      var w=pd.parentElement;
      if(!w || !w.classList.contains('select-wrapper') || w.querySelector('.icon-chevron-small')) return;
      var src=document.querySelector('.select-wrapper .icon-chevron-small');
      if(!src) return;
      var c=src.cloneNode(true);
      c.classList.remove('hidden');
      var none=w.querySelector('.icon-none');
      if(none) w.replaceChild(c,none); else w.appendChild(c);
    })();
    injectPdPlaceholder(document.querySelector('select[name="properties[PD]"]'));
    function isNAPd(){
      var v=(pd.value==null?'':(''+pd.value)).trim();
      if(!v) return false;
      return /^(na|n\/?a|none)$/i.test(v) || /^(n\/?a|none)\b/i.test(v);
    }
    function rxNonZero(){
      var names=['Sph (Right OD)','Sph (Left OS)','Cyl (Right OD)','Cyl (Left OS)','Axis (Right OD)','Axis (Left OS)'];
      for(var q=0;q<names.length;q++){
        var el=document.querySelector('select[name="'+names[q]+'"], select[name="properties['+names[q]+']"]');
        if(el && num(el.value)!==0) return true;
      }
      return false;
    }
    function pdUnset(){ var v=(pd.value==null?'':(''+pd.value)).trim(); return v==='' || v==='--'; }
    function advanceBlocked(){ return pdUnset() || (isNAPd() && rxNonZero()) || !rxSupported(); }
    function atcBlocked(){ return (rxNonZero() && (pdUnset() || isNAPd())) || !rxSupported(); }
    var HELP_PD=ecT('help-pd');
    function updateNext(){
      nextBtn.disabled=advanceBlocked();
      if(nextHelp){
        var msg = !rxSupported() ? ERR_RANGE : (pdUnset() ? HELP_PD : (advanceBlocked() ? ERR_NA : ''));
        nextHelp.textContent=msg;
        nextHelp.hidden=!msg;
      }
      syncBuy();
    }
    function clearErr(){
      var old=pdBlock.querySelector('[data-ec-pd-err]');
      if(old && old.parentNode){ old.parentNode.removeChild(old); measure(); }
    }
    function showErr(){
      var msg = !rxSupported() ? ERR_RANGE : (pdUnset() ? ERR_UNSET : ERR_NA);
      var old=pdBlock.querySelector('[data-ec-pd-err]');
      if(old){ if(old.textContent!==msg) old.textContent=msg; return; }
      var p=document.createElement('p');
      p.className='form-status__message form-status__message--error fs-body-75';
      p.setAttribute('data-ec-pd-err','');
      p.setAttribute('role','alert');
      p.textContent=msg;
      pdBlock.appendChild(p);
      measure();
    }
    var ERR_TINT=ecT('add-tint');
    var tintEls=[];
    tintNote=function(on, reveal){
      if(!on){
        if(!tintEls.length) return;
        tintEls.forEach(function(p){ if(p.parentNode) p.parentNode.removeChild(p); });
        tintEls=[];
        measure();
        return;
      }
      if(!tintEls.length){
        [[pdBlock.parentNode, pdBlock.nextSibling],[typeRow.parentNode, typeRow]].forEach(function(spot){
          var p=document.createElement('p');
          p.className='form-status__message form-status__message--error fs-body-75';
          p.setAttribute('data-ec-pd-err','');
          p.setAttribute('role','alert');
          p.textContent=ERR_TINT;
          spot[0].insertBefore(p, spot[1]);
          tintEls.push(p);
        });
        measure();
      }
      if(reveal){
        var box=tintEls[1].getBoundingClientRect();
        if(box.top<0 || box.bottom>window.innerHeight){ var calm=window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; try{ tintEls[1].scrollIntoView({behavior:calm?'auto':'smooth',block:'center'}); }catch(e4){} }
      }
    };

    var at=0;
    function measure(){ vp.style.height=screens[at].scrollHeight+'px'; }
    function go(i){
      var want=i|0; if(want<0) want=0; if(want>S_INDEX) want=S_INDEX;
      if(want===S_RX && usage!=='rx'){ usage='rx'; usageChosen=true; dropNaOption(); applyBase(); }
      if(want===S_INDEX && hasUsage && usage==='plano') want=S_TYPE;
      if(want>=S_TYPE){
        if(hasUsage && usage==='plano' && !pdUnset()){ }
        else if(!usage){ want=0; }
        else if(advanceBlocked()){ want=S_RX; showErr(); }
      }
      var prev=at;
      at=want;
      if(at!==S_RX && at!==S_TYPE) tintNote(false);
      notifyUsage();
      track.style.transform='translateX(-'+(at*100)+'%)';
      for(var s=0;s<screens.length;s++){
        var on=(s===at);
        screens[s].setAttribute('aria-hidden', on?'false':'true');
        screens[s].inert=!on;
        stepEls[s].classList.toggle('is-active', on);
        if(on) stepEls[s].setAttribute('aria-current','step');
        else stepEls[s].removeAttribute('aria-current');
      }
      stepEls[S_INDEX].hidden = hasUsage && usage==='plano';
      if(typeNext) typeNext.hidden = at!==S_TYPE || (hasUsage && usage==='plano');
      if(hasUsage){
        usePlano.classList.toggle('is-active', usage==='plano');
        useRx.classList.toggle('is-active', usage==='rx');
        usePlano.setAttribute('aria-pressed', usage==='plano'?'true':'false');
        useRx.setAttribute('aria-pressed', usage==='rx'?'true':'false');
      }
      if(at>prev){ try{ var f=screens[at].querySelector('.ec-lpw__nav[data-dir="back"]'); if(f) f.focus({preventScroll:true}); }catch(e2){} }
      measure();
      if(prev!==at) reveal(wrap,'start');
      syncBuy();
    }
    pd.addEventListener('change', function(){
      if(!advanceBlocked() && !atcBlocked()) clearErr();
      updateNext();
    });
    document.addEventListener('change', function(e){
      var n=(e.target && e.target.name) || '';
      var bare=n.replace(/^properties\[/,'').replace(/\]$/,'');
      if(bare!=='PD' && !/^(Sph|Cyl)\b/i.test(bare)) return;
      if(!advanceBlocked() && !atcBlocked()) clearErr();
      updateNext();
    });
    updateNext();

    var buyForm=meta.querySelector('form[action*="/cart/add"]');
    var atcBtn=buyForm?buyForm.querySelector('[name=add]'):null;
    var atcTxt=atcBtn?atcBtn.querySelector('[data-add-to-cart-text]'):null;
    var finTxt=null, atcAria=null, themeOff=atcBtn?atcBtn.disabled:false, lastOff=themeOff;
    if(atcTxt){
      finTxt=document.createElement('span');
      finTxt.setAttribute('data-ec-lp-finish','');
      finTxt.textContent=ecT('finish');
      finTxt.hidden=true;
      atcTxt.parentNode.insertBefore(finTxt, atcTxt.nextSibling);
      atcAria=atcBtn.getAttribute('aria-label');
    }
    function lensComplete(){
      if(hasUsage && !usage) return false;
      if(at!==((hasUsage && usage==='plano') ? S_TYPE : S_INDEX)) return false;
      return !advanceBlocked() && !atcBlocked() && !tintClash();
    }
    function checksPending(){
      var api=window.ECRequiredChecks;
      return (api && api.pending) ? api.pending(buyForm) : 0;
    }
    syncBuy=function(){
      if(!finTxt) return;
      var done=lensComplete() && !checksPending();
      if(atcBtn.disabled!==lastOff) themeOff=atcBtn.disabled;
      var hard=themeOff || !findVar(idxSel.value,typeSel.value);
      var soft=!done && !hard;
      if(finTxt.hidden!==done) finTxt.hidden=done;
      if(atcTxt.hidden!==!done) atcTxt.hidden=!done;
      if(atcBtn.disabled!==hard) atcBtn.disabled=hard;
      lastOff=hard;
      if(atcBtn.classList.contains('disabled')!==soft) atcBtn.classList.toggle('disabled', soft);
      if(hard || soft) atcBtn.setAttribute('aria-disabled','true'); else atcBtn.removeAttribute('aria-disabled');
      var aria=done ? atcAria : finTxt.textContent;
      if(aria!==null && atcBtn.getAttribute('aria-label')!==aria) atcBtn.setAttribute('aria-label', aria);
      var pay=buyForm.querySelector('[data-shopify="payment-button"]');
      if(pay){
        if(pay.inert!==!done) pay.inert=!done;
        if(done) pay.removeAttribute('aria-disabled'); else pay.setAttribute('aria-disabled','true');
      }
    };
    function syncBuySoon(){ setTimeout(syncBuy,0); setTimeout(syncBuy,120); }
    if(atcBtn){
      document.addEventListener('change', syncBuySoon);
      document.addEventListener('ec:lens-usage', syncBuySoon);
      document.addEventListener('click', function(e){ if(e.target.closest && e.target.closest('.product__color-swatch')) syncBuySoon(); });
      if(window.MutationObserver) new MutationObserver(syncBuy).observe(atcBtn,{attributes:true,attributeFilter:['disabled']});
      if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', syncBuy);
    }
    function guardAtc(e){
      var pdMirror=document.querySelector('select[name="properties[PD]"]');
      if(pdMirror && (''+pdMirror.value).trim()===''){
        pdMirror.disabled=true;
        setTimeout(function(){ pdMirror.disabled=false; },0);
      }
      if(!lensBlocked()){ if(window.ECRequiredChecks) window.ECRequiredChecks.block(e, buyForm); return; }
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    }
    function reveal(node, block){
      if(!node || !node.scrollIntoView) return;
      var calm=window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      try{ node.scrollIntoView({behavior:calm?'auto':'smooth',block:block}); }catch(e5){}
    }
    function rxBlocked(){
      if(tintClash()){ refresh(); go(S_TYPE); tintNote(true, true); return true; }
      if(!atcBlocked()){ clearErr(); return false; }
      go(S_RX); showErr();
      reveal(pdBlock.querySelector('[data-ec-pd-err]') || wrap,'center');
      return true;
    }
    function lensBlocked(){
      if(rxBlocked()) return true;
      if(lensComplete()) return false;
      if(hasUsage && !usage) go(S_USAGE);
      else if(hasUsage && usage==='plano') go(S_TYPE);
      else go(Math.min(at+1, S_INDEX));
      var err=at===S_RX ? pdBlock.querySelector('[data-ec-pd-err]') : null;
      if(err) reveal(err,'center'); else reveal(wrap,'start');
      return true;
    }
    if(buyForm){
      buyForm.setAttribute('data-ec-checks-guarded','');
      buyForm.__ecLensRxBlocked=lensBlocked;
      document.addEventListener('click', function(e){
        var t=e.target; if(!t || !t.closest) return;
        var hit=t.closest('[name=add], [data-shopify="payment-button"]');
        if(!hit || !buyForm.contains(hit)) return;
        guardAtc(e);
      }, true);
      document.addEventListener('submit', function(e){
        if(e.target===buyForm) guardAtc(e);
      }, true);
    }

    wizardGo=function(){ if(!(hasUsage && usage==='plano')) go(S_INDEX); };
    window.addEventListener('resize', measure);
    if(window.ResizeObserver){ var ro=new ResizeObserver(measure); screens.forEach(function(s){ ro.observe(s); }); }
    go(0);
  })();

  function setIndex(val){ if(idxSel.value!==val){ idxSel.value=val; idxSel.dispatchEvent(new Event('change',{bubbles:true})); } refresh(); }
  function setType(val){
    var prevType=typeSel.value, prevIdx=idxSel.value;
    typeSel.value=val;
    var target=resolveIndexFor(val, rules());
    if(target) idxSel.value=target;
    if(idxSel.value!==prevIdx) idxPicked=false;
    if(typeSel.value!==prevType) typeSel.dispatchEvent(new Event('change',{bubbles:true}));
    if(idxSel.value!==prevIdx) idxSel.dispatchEvent(new Event('change',{bubbles:true}));
    refresh();
  }

  function pickType(val){
    var r=rules();
    function ok(c){ return !!c && resolveIndexFor(c,r)!==null; }
    var cur=partsOf(typeSel.value);
    var on=cur.indexOf(val);
    if(on>-1){ if(cur.length>1) setType(cur[1-on]); return; }
    var next=null;
    if(cur.length>1){
      if(ok(comboVal(val,cur[1]))) next=comboVal(val,cur[1]);
      else if(ok(comboVal(val,cur[0]))) next=comboVal(val,cur[0]);
    } else if(ok(comboVal(val,cur[0]))) next=comboVal(val,cur[0]);
    setType(next || val);
  }
  function hasPartner(val){
    var m=comboOf[val];
    if(!m) return false;
    var r=rules();
    for(var k in m){ if(resolveIndexFor(m[k],r)!==null) return true; }
    return false;
  }
  function priceAt(typeVal, idxVal){
    var v=findVar(idxVal,typeVal);
    return v ? v.p : null;
  }

  function money(cents){ return window.ECMoney(cents, 'whole'); }
  function findVar(idxVal,typeVal){
    var color=colorVal();
    for(var i=0;i<D.variants.length;i++){
      var v=D.variants[i];
      if(v.a && vOpt(v,idxPos)===idxVal && vOpt(v,typePos)===typeVal && (!color || vOpt(v,colorPos)===color)) return v;
    }
    return null;
  }
  function rxSupported(){
    var r=rules();
    for(var i=0;i<D.indexValues.length;i++){ if(idxAllowed(D.indexValues[i],r) && idxHasStock(D.indexValues[i])) return true; }
    return false;
  }
  function demoVal(){ for(var i=0;i<D.indexValues.length;i++){ if(isDemo(D.indexValues[i])) return D.indexValues[i]; } return null; }
  function rules(){
    var rx=rxState();
    return { rx: rx, tintOff: hasAdd(), cylForcesSpecial: !!specialVal && rx.maxCyl > 2 && idxHasStock(specialVal) };
  }
  function idxAllowed(val, r){
    if(r.cylForcesSpecial) return isSpecial(val);
    if(isDemo(val)) return !r.rx.anyRx && !isRxPath();
    if(isSpecial(val)) return true;
    return indexMax(val) >= r.rx.maxSph;
  }
  function resolveIndexFor(typeVal, r){
    if(r.tintOff && isTint(typeVal)) return null;
    if(r.cylForcesSpecial) return findVar(specialVal,typeVal) ? specialVal : null;
    var j;
    if(isPlano()){
      var dv=demoVal();
      if(dv && idxAllowed(dv,r) && findVar(dv,typeVal)) return dv;
    } else {
      var cur=idxSel.value;
      if((idxPicked || !r.rx.anyRx) && cur && idxAllowed(cur,r) && findVar(cur,typeVal)) return cur;
      if(r.rx.anyRx){
        var rec=recIndex(r);
        if(indexNum(rec)<=AUTO_INDEX_MAX && idxAllowed(rec,r) && findVar(rec,typeVal)) return rec;
      }
    }
    for(j=0;j<ladder.length;j++){ if(idxAllowed(ladder[j],r) && findVar(ladder[j],typeVal)) return ladder[j]; }
    if(specialVal && findVar(specialVal,typeVal)) return specialVal;
    return null;
  }

  function recIndex(r){
    var need=-1;
    for(var i=0;i<ladder.length;i++){ if(indexMax(ladder[i])>=r.rx.maxSph){ need=i; break; } }
    if(need===-1) need=ladder.length-1;
    return ladder[Math.min(need+1, ladder.length-1)];
  }
  function baseType(r){
    var order=singleTypes.filter(function(t){ return /^Standard\b/i.test(t); }).concat(D.typeValues);
    for(var i=0;i<order.length;i++){ if(resolveIndexFor(order[i],r)!==null) return order[i]; }
    return null;
  }
  function applyBase(){
    var r=rules();
    var base=(typePicked && resolveIndexFor(typeSel.value,r)!==null) ? null : baseType(r);
    if(base) setType(base); else refresh();
  }

  function paint(r){
    r = r || rules();
    var recVal = recIndex(r);
    var curType=typeSel.value;

    var curParts=partsOf(curType);
    typeRow.querySelectorAll('.ec-lp__card').forEach(function(el){
      var t=el.getAttribute('data-val');
      var ri=resolveIndexFor(t, r);
      setOff(el, ri===null);
      var pair=null, partner=null;
      if(hasCombos && ri!==null){
        var on=curParts.indexOf(t);
        if(on>-1){
          if(curParts.length>1){ pair=curType; partner=curParts[1-on]; }
        } else {
          for(var ci=curParts.length-1; ci>=0; ci--){
            var cv=comboVal(t,curParts[ci]);
            if(cv && resolveIndexFor(cv,r)!==null){ pair=cv; partner=curParts[ci]; break; }
          }
        }
      }
      var d=el.querySelector('[data-delta]');
      if(!d) return;
      if(!D.showDeltas || ri===null){ d.textContent=''; return; }
      var diff=null;
      if(pair){
        var pi=resolveIndexFor(pair,r);
        var pp=priceAt(pair,pi), bp=priceAt(partner,pi);
        if(pp!==null && bp!==null) diff=pp-bp;
      }
      if(diff===null){
        var own=findVar(ri,t).p, base=own;
        D.typeValues.forEach(function(t2){ var v2=findVar(ri,t2); if(v2 && v2.p<base) base=v2.p; });
        diff=own-base;
      }
      d.textContent = diff>0 ? '+'+money(diff) : ecT('included');
    });

    var idxPrices={}, idxMin=Infinity;
    idxRow.querySelectorAll('.ec-lp__box').forEach(function(box){
      var val=box.getAttribute('data-val');
      var v=idxAllowed(val,r) ? findVar(val,curType) : null;
      var disabled=!v;
      if(v){ idxPrices[val]=v.p; if(v.p<idxMin) idxMin=v.p; }
      setOff(box, disabled);
      box.hidden=isDemo(val) && isRxPath();
      var existing=box.querySelector('.ec-lp__badge');
      var wantBadge = (val===recVal) && D.badgeText && !disabled;
      if(wantBadge && !existing){ var b=document.createElement('span'); b.className='ec-lp__badge'; b.textContent=D.badgeText; box.appendChild(b); }
      else if(!wantBadge && existing){ existing.remove(); }
    });
    idxRow.querySelectorAll('.ec-lp__box').forEach(function(box){
      var val=box.getAttribute('data-val');
      var d=box.querySelector('[data-idelta]');
      if(!d) return;
      if(!D.showDeltas || idxPrices[val]==null){ d.textContent=''; return; }
      var diff=idxPrices[val]-idxMin;
      d.textContent = diff>0 ? '+'+money(diff) : ecT('included');
    });
    syncActive();
    syncBuy();
  }

  function refresh(){
    var r=rules();
    var prevType=typeSel.value, prevIdx=idxSel.value;
    var target=resolveIndexFor(typeSel.value, r);
    if(target===null){
      var tryOrder=(comboParts[typeSel.value] || []).concat((r.tintOff && isTint(typeSel.value)) ? [baseType(r)] : [], D.typeValues);
      for(var i=0;i<tryOrder.length;i++){
        var alt=tryOrder[i] ? resolveIndexFor(tryOrder[i], r) : null;
        if(alt!==null){ typeSel.value=tryOrder[i]; target=alt; break; }
      }
    }
    if(target!==null) idxSel.value=target;
    if(idxSel.value!==prevIdx) idxPicked=false;
    if(typeSel.value!==prevType) typeSel.dispatchEvent(new Event('change',{bubbles:true}));
    if(idxSel.value!==prevIdx) idxSel.dispatchEvent(new Event('change',{bubbles:true}));
    if(r.tintOff && isTint(prevType) && !isTint(typeSel.value)) tintNote(true);
    else if(!r.tintOff) tintNote(false);
    paint(r);
  }

  function syncActive(){
    idxRow.querySelectorAll('.ec-lp__box').forEach(function(b){ var on=b.getAttribute('data-val')===idxSel.value; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on?'true':'false'); });
    var parts=partsOf(typeSel.value);
    typeRow.querySelectorAll('.ec-lp__card').forEach(function(c){ var on=parts.indexOf(c.getAttribute('data-val'))>-1; c.classList.toggle('is-active', on); c.setAttribute('aria-pressed', on?'true':'false'); });
  }

  document.addEventListener('change', function(e){
    var n=e.target && e.target.name || '';
    var bare=n.replace(/^properties\[/,'').replace(/\]$/,'');
    if(/^(Sph|Cyl|Axis|Add)\b/i.test(bare)) refresh();
    else if(n==='id' || /options\[/.test(n)) { paint(); }
  });
  document.addEventListener('click', function(e){ if(e.target.closest && e.target.closest('.product__color-swatch')) setTimeout(function(){ if(usageChosen) applyBase(); else refresh(); },60); });

  refresh();

  (function(){
    try{ if(new URL(location.href).searchParams.get('variant')) return; }catch(e){}
    var color=colorVal();
    var avail=D.variants.filter(function(v){ return v.a && (!color || vOpt(v,colorPos)===color); });
    if(!avail.length) return;
    var minP=avail.reduce(function(m,v){ return v.p<m?v.p:m; }, Infinity);
    var pool=avail.filter(function(v){ return v.p===minP; });
    var cheap=null;
    for(var ci=0;ci<pool.length;ci++){ var iv=vOpt(pool[ci],idxPos); if(!isDemo(iv) && !isSpecial(iv)){ cheap=pool[ci]; break; } }
    cheap=cheap||pool[0];
    typeSel.value=vOpt(cheap,typePos);
    idxSel.value=vOpt(cheap,idxPos);
    typeSel.dispatchEvent(new Event('change',{bubbles:true}));
    idxSel.dispatchEvent(new Event('change',{bubbles:true}));
    refresh();
  })();
})();
